<template>
    <div class="p-grid data-table data-table-list">
        <div class="p-col-12">
            <div class="payout-buttons">
                <Button @click="generateAll()" label="Initialize payouts for all users (not visible to users)" />
                <Button @click="convertPending()" label="Make init payouts pending (visible to users)" />
            </div>
            <div class="payout-buttons">
                <Button @click="previousWeek()" label="Previous" />
                <InputText type="text" v-model="range" placeholder="range" disabled/>
                <Button @click="nextWeek()" label="Next" />
            </div>
            <div class="card card-w-title">

                <DataTable :value="payouts" class="p-datatable-responsive" :paginator="true" :rows="10" :filters="filters" :autoLayout="true">
                    <template #header>
                        <h2>List of payouts</h2>
                    </template>
                    <Column field="id" header="Payout ID" :sortable="true">
                        <template #body="slotProps">
                            <span>{{ slotProps.data.id }}</span>
                        </template>
                    </Column>
                    <Column field="user_id" header="Client ID" :sortable="true">
                        <template #body="slotProps">
                            <span>{{ slotProps.data.user_id }}</span>
                        </template>
                    </Column>
                    <Column field="time" header="Time:" :sortable="true">
                        <template #body="slotProps">
                            <span class="time">{{ formatDate(slotProps.data.time) }}</span>
                        </template>
                    </Column>
                    <Column field="status" header="Status" :sortable="true" filterMatchMode="contains">
                        <template #body="slotProps">
                            <span class="status">{{ slotProps.data.status }}</span>
                        </template>
                    </Column>
                    <Column field="amount" header="Amount" :sortable="true">
                        <template #body="slotProps">
                            <span>{{ formatCurrency(slotProps.data.amount) }}</span>
                        </template>
                    </Column>
                    <Column field="payment_type" header="Payment type" :sortable="true">
                        <template #body="slotProps">
                            <!--<span>{{ slotProps.data.payment_type }}</span>-->
                            <Dropdown v-model="slotProps.data.payment_type" :options="types.payment" class="p-column-filter" :change="paymentChanged(slotProps.data.id,slotProps.data.payment_type)">
                                <template #option="payment_type">
                                    <span>{{ payment_type.option }}</span>
                                </template>
                            </Dropdown>
                        </template>
                      
                    </Column>

                    <Column field="name" header="Name" :sortable="true">
                        <template #body="slotProps">
                            <span>{{ slotProps.data.name }}</span>
                        </template>
                    </Column>
                    <Column field="action" header="Action" :sortable="true">
                        <template #body="slotProps">
                            <span class="actions">
                                <Button label="Fin data" icon="icon pi pi-dollar" class="btn-secondary" @click="openUserProfile(slotProps.data.user_id, slotProps.data.email)" />
                                <Button v-if="slotProps.data.status=='Pending'" class="btn-secondary" label="Approve" @click="approvePayout(slotProps.data.id)" icon="icon pi pi-check" />
                                <Button v-if="slotProps.data.status=='Hidden'" class="btn-secondary" label="Remove" @click="removePayout(slotProps.data.id)" icon="icon pi pi-times" />
                            </span>
                        </template>
                    </Column>
                </DataTable>

            </div>

            <Dialog :header="title" :visible.sync="display" :style="{width: '30vw'}" :modal="true">
                <h4>This will clear all currenty generated (hidden) payouts!</h4>
                <template #footer>
                    <div class="p-grid">
                        <div class="p-md-6">
                            <Button label="Approve" @click="generateAll()" icon="pi pi-check" class="p-button-success" />
                            <Button label="Deny" @click="closeDialog()" icon="pi pi-times" class="p-button-danger" />
                        </div>
                    </div>
                </template>
            </Dialog>

            <Dialog :header="financial.title" :visible.sync="financial.display" :style="{width: '50vw'}" :modal="true">
                <div class="card card-w-title">
                    <div class="content-data">
                        <h2>Personal data</h2>
                        <div class="data-item">
                            <p>Address</p>
                            <p>{{ financial.data.address }}</p>
                        </div>
                        <div class="data-item">
                            <p>ZIP</p>
                            <p>{{ financial.data.zip }}</p>
                        </div>
                        <div class="data-item">
                            <p>City</p>
                            <p>{{ financial.data.city }}</p>
                        </div>
                        <div class="data-item">
                            <p>Country</p>
                            <p>{{ financial.data.country }}</p>
                        </div>
                    </div>
                    <div class="content-data">
                        <h2>Financial data</h2>
                        <div class="data-item">
                            <p>Account Name</p>
                            <p>{{ financial.data.account_name }}</p>
                        </div>
                        <div class="data-item">
                            <p>Account number</p>
                            <p>{{ financial.data.account_number }}</p>
                        </div>
                        <div class="data-item">
                            <p>Account signatory person</p>
                            <p>{{ formatDate(financial.data.account_signatory_person) }}</p>
                        </div>
                        <div class="data-item">
                            <p>SWIFT</p>
                            <p>{{ financial.data.swift }}</p>
                        </div>
                        <div class="data-item">
                            <p>IBAN</p>
                            <p>{{ financial.data.iban }}</p>
                        </div>
                        <div class="data-item">
                            <p>BTC wallet</p>
                            <p>{{ financial.data.btc_wallet }}</p>
                        </div>
                        <div class="data-item">
                            <p>Bank name</p>
                            <p>{{ financial.data.bank_name }}</p>
                        </div>
                        <div class="data-item">
                            <p>Bank Address</p>
                            <p>{{ financial.data.bank_address }}</p>
                        </div>
                        <div class="data-item">
                            <p>Bank ZIP</p>
                            <p>{{ financial.data.bank_zip }}</p>
                        </div>
                        <div class="data-item">
                            <p>Bank city</p>
                            <p>{{ financial.data.bank_city }}</p>
                        </div>
                        <div class="data-item">
                            <p>Bank country</p>
                            <p>{{ financial.data.bank_country }}</p>
                        </div>
                    </div>
                </div>
                <template #footer>
                    <div class="p-grid">
                        <div class="p-md-6 p-offset-6">
                            <Button label="Close" @click="closeDialog()" icon="pi pi-times" class="p-button" />
                        </div>
                    </div>
                </template>
            </Dialog>

        </div>

    </div>
</template>

<script>

    import PayoutService from '../../service/PayoutService';
    import UserService from '../../service/UserService';

    export default {
        data() {
            return {
                start_date: null,
                end_date: null,
                range: null,
                payouts: null,
                filters: {},
                activeRow: {},
                display: false,
                title: '',
                message: '',
                financial: {
                    display: false,
                    title: '',
                    data: {
                        address: '',
                        zip: '',
                        city: '',
                        country: '',
                        account_name: '',
                        account_number: '',
                        account_signatory_person: '',
                        swift: '',
                        iban: '',
                        btc_wallet: '',
                        bank_name: '',
                        bank_address: '',
                        bank_zip: '',
                        bank_city: '',
                        bank_country: '',
                    }
                },
                types: {
                    payment: ['BNK', 'CRY', 'CSH', 'CC'],
                },
            }
        },
        created() {
            this.$store.commit('setPageTitle', { pageTitle: 'Payouts' });
            this.payoutService = new PayoutService();
            this.userService = new UserService();

        },
        async mounted() {

            var curr;
            curr = new Date();
            var fridayDate;
            fridayDate = new Date();
            var friday;
            friday = 5 - curr.getDay();
            fridayDate.setDate(fridayDate.getDate() + friday);
            fridayDate.setHours(23, 59, 59, 999);
            this.end_date = fridayDate;
            this.range = this.end_date.toDateString();

            this.loadData();

        },
        methods: {
            async paymentChanged(id,value) {
                //console.log(id + ' ' +value);

                await this.payoutService.changeType(id, value);

            },

            async generateAll() {

                await this.payoutService.generateAll(this.$store.state.currentUser.token);
                this.loadData();
            },
            async convertPending() {
                await this.payoutService.convertPending(this.$store.state.currentUser.token);
                this.loadData();
            },

            async previousWeek() {
                this.end_date = addDays(this.end_date, -7);
                this.range = this.end_date.toDateString();
                  this.loadData();

            },
              async nextWeek() {
                this.end_date = addDays(this.end_date, 7);
                this.range = this.end_date.toDateString();
                  this.loadData();

            },

            async removePayout(id) {

                await this.payoutService.removePayout(id, this.$store.state.currentUser.token);
                this.loadData();
            },
            async approvePayout(id) {

                await this.payoutService.approvePayout(id, this.$store.state.currentUser.token);
                this.loadData();
            },

            openDialog() {
                this.dispay = true;
            },
            async  closeDialog() {
                this.display = false;
                this.financial.display = false;
            },

            formatDate(date) {
                var d = new Date(date),
                    month = "" + (d.getMonth() + 1),
                    day = "" + d.getDate(),
                    year = d.getFullYear(),
                    hours = "" + d.getHours(),
                    mins = "" + d.getMinutes();

                if (month.length < 2) month = "0" + month;
                if (day.length < 2) day = "0" + day;
                if (hours.length < 2) hours = "0" + hours;
                if (mins.length < 2) mins = "0" + mins;

                return [year, month, day].join("-") + " " + hours + ":" + mins;
            },
            formatCurrency(value) {
                return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(value);
            },
            async loadData() {
                this.payouts = await this.payoutService.listPayouts(0, this.$store.state.currentUser.token, this.end_date);
                console.log(this.payouts);
            },

            async openUserProfile(user_id, email) {
                let user = await this.userService.getUser(user_id, this.$store.state.currentUser.token);

                this.financial.data = {
                    address: user.address,
                    zip: user.zip,
                    city: user.city,
                    country: user.country,
                    account_name: user.account_name,
                    account_number: user.account_number,
                    account_signatory_person: user.account_signatory_person,
                    swift: user.swift,
                    iban: user.iban,
                    btc_wallet: user.btc_wallet,
                    bank_name: user.bank_name,
                    bank_address: user.bank_address,
                    bank_zip: user.bank_zip,
                    bank_city: user.bank_city,
                    bank_country: user.bank_country,
                }

                this.financial.display = true;
                this.financial.data.id = user_id
                this.financial.title = 'Financial data for user: ' + email
            },
        }
    }

    function addDays(date, days) {
        var result = new Date(date);
        result.setDate(result.getDate() + days);
        return result;
    }
</script>

<style scoped>

    .p-button {
        margin-left: 10px
    }
</style>